module.exports = __webpack_public_path__ + "img/pic_14.d204b590.jpg";